import React from "react";
import { Icon } from "signoxe/components/widgets";
import { CampaignPropType } from "signoxe/constants/propTypes";
import "./styles.scss";

const CampaignTile = ({ campaign, onDelete, onView }) => {
  return (
    <div className="Campaign">
      <div className="Campaign__content" onClick={() => onView(campaign)}>
        <Icon title="folder" name="folder" size="2.25rem" color="black" />
        <h3 className="hide-for-desktop">{truncate(campaign.name, 6)}</h3>
        <h3 className="hide-for-mobile">{truncate(campaign.name, 15)}</h3>

      </div>

      <div className="Campaign__footer">
        <Icon
          title="cancel"
          name="trash"
          size="1.25rem"
          color="black"
          onClick={() => onDelete(campaign)}
        />
      </div>
    </div>
  );
};

CampaignTile.propTypes = {
  campaign: CampaignPropType.isRequired,
};

export default CampaignTile;

export const truncate = (str, n) => {
  return str.length > n ? str.substr(0, n - 1) + "..." : str;
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/CampaignTile/index.js